import type { ReactNode } from "react";
import { PolicyDocument, type TermsData } from "@dwelldrop/shared";
import { PolicyMarkdown } from "../../ui/PolicyMarkdown";

type PrivacyModalProps = {
  data: TermsData;
  version?: number;
  whatsNew?: string;
  onClose: () => void;
  /** Override backdrop (e.g. z-index when nested inside another modal). */
  backdropClassName?: string;
};

const renderPolicyMarkdown = (markdown: string): ReactNode => (
  <PolicyMarkdown>{markdown}</PolicyMarkdown>
);

export default function PrivacyModal({
  data,
  version,
  whatsNew,
  onClose,
  backdropClassName = "fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50 p-4",
}: PrivacyModalProps) {
  return (
    <div
      className={backdropClassName}
      data-testid="privacy-modal"
      onClick={onClose}
    >
      <div
        className="max-h-[90vh] w-full max-w-3xl overflow-y-auto rounded-2xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Gradient header */}
        <div className="sticky top-0 z-10 rounded-t-2xl bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/20">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-shield h-6 w-6"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
                </svg>
              </div>
              <div>
                <h2 className="text-center text-2xl font-bold">
                  Privacy Policy
                </h2>
              </div>
            </div>
            <button
              className="text-2xl font-light text-white/80 hover:text-white"
              onClick={onClose}
            >
              ×
            </button>
          </div>
        </div>

        <div className="space-y-4 p-6">
          <PolicyDocument
            data={data}
            policyName="privacy_policy_venue"
            version={version ?? data.version}
            whatsNew={whatsNew}
            renderMarkdown={renderPolicyMarkdown}
          />

          {/* Close Button */}
          <button
            onClick={onClose}
            className="w-full rounded-lg bg-gradient-to-r from-green-500 to-green-600 px-4 py-3 text-base font-semibold text-white transition-all duration-200 hover:scale-105 hover:shadow-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
